import { Component, OnInit, Injector }      from '@angular/core';
import User from 'src/app/models/User';
import { BackendService } from 'src/app/_service/backend.service';
import { ZimbraInstanceService } from 'src/app/_service/zimbrainstance.service';
import { BaseComponent }                    from '../BaseComponent';

@Component({
  selector        : 'auslroma-ldap-login',
  templateUrl     : './AuslRomaLdapLoginComponent.html',
  styleUrls       : ['./AuslRomaLdapLoginComponent.css'],
})

export class AuslRomaLdapLoginComponent extends BaseComponent implements OnInit {

  user            : User = new User();
  loading         : boolean = false;
  settings        : Object;
  remember_me     : boolean = false;
  redirect_to     : string = 'dashboard';
  login_type_selected : string = "p";

  constructor(
    injector : Injector,
    private _backendService   : BackendService,
    private _zimbraInstanceService : ZimbraInstanceService
    ) 
  { 
      super(injector);
      this.login = this.login.bind(this);
  }

  ngOnInit() 
  {
   
  }

  softwareSettings() {
    this._backendService.getSoftwareSettings().subscribe(
        data => {
            var localstorage_key = this.project_labels + "_software_settings";
            localStorage.setItem(localstorage_key, JSON.stringify(data));
        },
        err => {
            let error_message = err.message !== undefined ? err.message : err.error;
        },
    );
}

  login() 
    {
        this.loading                = true;
        this.errors                 = false;
        this.error_message          = '';
        this.error_detailed_message = '';
        this.error_trace            = '';

        if (this.user.username && this.user.password) 
        {

            this.user.username = this.user.username.replace("@aslroma1.it" , "");
            this.user.username = this.user.username.replace("@labs.it" , "");
            this.user.username = this.user.username.toLowerCase();
            this.user.username = this.user.username.trim();

            this._userService.login({ 'username': this.user.username, 'password': this.user.password , 'remember_me' : this.remember_me })
                .subscribe(
                    data => {
                        if (data['success']) {

                            var auto_login_zimbra = this.getSettingValue("auto_login_zimbra");
                            if (auto_login_zimbra)
                            {
                                this.zimbraLogin(data['success']);
                            }
                            else
                            {
                                this.normalLogin(data['success']);
                            }
                           
                        }
                        if (data['error']) {
                            this.handleErrorFromResponse(data['error']);
                            this.loading = false;
                        }
                    },
                    error => 
                    {
                        if (error['error']) {
                            error = error['error'];
                        }
                        this.handleErrorFromResponse(error);
                        this._interfaceService.openSimpleErrorSnackBar(this.error_trace);
                        this.loading = false;
                    });
        } 
        else 
        {
            this.errors = true;
            this.error_message = this._translateService.instant("generic.login_required");
            this.loading = false;
        }
    }

    normalLogin(data)
    {
        this._userService.storeUserData(data);
        if (this._route.snapshot.queryParams['path']) {
            this.redirect_to = this._route.snapshot.queryParams['path'];
        } 
        else if (this._route.url) 
        {
            this.redirect_to = this._router.url;
        }

        var user_info = JSON.parse(this._localStorageService.getWatchedLocalStorage(this.project_labels + "_user_info"));

        // Chiediamo nuovamente la sowtware settings per aggiornare eventuali elementi cambiati
        this.softwareSettings();
        if (user_info["is_superuser"])
        {
            this._router.navigate(['dashboard', 'admin' ]);
        }
        else
        {
            this._router.navigate([ 'dashboard' ]);
        }
        this.loading = false;
    }

    zimbraLogin(data_user)
    {
        this._zimbraInstanceService.zimbraLogin().subscribe(
            data => {
                var ass = data["retdata"]["data"];
                if (ass === "zimbrainstance.no_association")
                {
                    this.normalLogin(data_user);
                }
                else
                {
                    var  redirect_parameter_url = "";
                    switch(this.login_type_selected)
                    {
                        case "a" : redirect_parameter_url = "&redirectURL=/?client=advanced"; break;
                        case "m" : redirect_parameter_url = "&redirectURL=/m/zmain"; break;
                        case "h" : redirect_parameter_url = "&redirectURL=/h/search?mesg=welcome&init=true"; break;
                    }

                    var final_redirect_url = data["retdata"]["data"] + redirect_parameter_url;

                    window.open(final_redirect_url, "_self");
                }
                
            },
            err => {
                this.loading = false;
                this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
            })
    }
}
